import { render, staticRenderFns } from "./pending-order-details.vue?vue&type=template&id=fb04e602&scoped=true&"
import script from "./pending-order-details.vue?vue&type=script&lang=js&"
export * from "./pending-order-details.vue?vue&type=script&lang=js&"
import style0 from "./pending-order-details.vue?vue&type=style&index=0&id=fb04e602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb04e602",
  null
  
)

export default component.exports